import { render } from "./SurnameField.vue?vue&type=template&id=5eadfca7"
import script from "./SurnameField.vue?vue&type=script&lang=js"
export * from "./SurnameField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__